import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton, Typography as MuiTypography, } from '@mui/material';
import { theme } from '../themes/theme';
const getFontSize = (variant) => {
    switch (variant) {
        case 'h1':
            return theme.typography.h1.fontSize;
        case 'h2':
            return theme.typography.h2.fontSize;
        case 'h3':
            return theme.typography.h3.fontSize;
        case 'h4':
            return theme.typography.h4.fontSize;
        case 'h5':
            return theme.typography.h5.fontSize;
        case 'h6':
            return theme.typography.h6.fontSize;
        case 'subtitle1':
            return theme.typography.subtitle1.fontSize;
        case 'subtitle2':
            return theme.typography.subtitle2.fontSize;
        case 'body1':
            return theme.typography.body1.fontSize;
        case 'body2':
            return theme.typography.body2.fontSize;
        case 'caption':
            return theme.typography.caption.fontSize;
        case 'button':
            return theme.typography.button.fontSize;
        case 'overline':
            return theme.typography.overline.fontSize;
        default:
            return '1rem';
    }
};
export const Typography = (props) => {
    const { isLoading, skeletonSx, skeletonHeight, skeletonWidth, ...typographyProps } = props;
    if (isLoading) {
        const fontSize = getFontSize(typographyProps.variant);
        return (_jsx(Skeleton, { variant: "text", width: skeletonWidth, height: skeletonHeight, sx: { fontSize, ...skeletonSx } }));
    }
    return (_jsx(MuiTypography, { ...typographyProps, component: typographyProps.component ?? 'div' }));
};
